import { useState } from 'react'
import { useSearchParams } from 'react-router-dom'
import FilterModelPro, { GridFilterModelPro } from '../utils/filterModelPro'

export const filtroVazio: GridFilterModelPro = {
    items: [] as GridFilterModelPro['items'],
    quickFilterValue: '',
}

const useDefaultFilterModel = (
    initialFilterModel: GridFilterModelPro = {} as any,
    dontRedirect = false,
) => {
    const [searchParams] = useSearchParams()
    const urlFilter = searchParams.get('grid-filter')

    if (urlFilter && !dontRedirect) {
        const filter = FilterModelPro.fromUrlParams(urlFilter).filterModel
        if (filter.items.length) initialFilterModel = filter
        searchParams.delete('grid-filter')
        window.history.replaceState(
            {},
            '',
            `${window.location.pathname}?${searchParams}`,
        )
    }

    const [filterModel, setFilterModel] = useState<GridFilterModelPro>({
        items: initialFilterModel.items || [],
        quickFilterValue: initialFilterModel.quickFilterValue || '',
    })
    return [filterModel, setFilterModel] as const
}

export default useDefaultFilterModel
